<template>
    <div>
        <b-row>
            <b-col md="12" class="my-1">
                <h3 class="text-themecolor">ML triggers ({{ count }})</h3>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <div class="card">
                    <div class="card-body">
                        <!-- User Interface controls -->
                        <b-row>
                            <b-col md="12" class="my-1">
                                <b-form-group class="mb-0">
                                    <b-input-group>
                                        <b-form-input v-model="filter" :placeholder="$t('datatables.zoeken')" ref='search' />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!-- User Interface controls -->
                        <!-- Main table element -->
                        <b-row>
                            <b-col md="12">
                                <b-table class="table-hover"
                                         show-empty
                                         :items="TriggerProvider" 
                                         :empty-text='getEmptyText(count)'
                                         :fields="fields"
                                         :sort-desc.sync="sortDesc"
                                         :current-page="currentPage" 
                                         :per-page="perPage" 
                                         :filter="filter"
                                         @row-clicked="onRowClicked"
                                         ref="table"
                                         >
                                         <template v-slot:table-busy>
                                            <PreLoader/>
                                         </template>
                                         <template v-slot:cell(actions)="row">
                                            <delete title="ML trigger" class="ml-1" :noRedirect="true" :hideText="true" :id="row.item.id" namespace="fmmodule" size="m" resource="mltriggers" @onDeleted="onTriggerDeleted()" /> 
                                        </template>
                                </b-table>
                            </b-col>
                        </b-row>
                        <!-- Main table element -->
    
                        <!-- Pagination controls -->
                        <b-row>
                            <b-col md="12" lg="5">
                                <b-form-group label-cols :label="$t('datatables.perpagina')">
                                    <b-form-select :options="pageOptions" v-model="perPage" />
                                </b-form-group>
                            </b-col>
                            <b-col md="12" lg="7">
                                <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
                            </b-col>
                        </b-row>
                        <!-- Pagination controls -->
                    </div>
                </div>
            </b-col>
        </b-row>
        
    </div>
    </template>
    <script>
    //Import store
    import { mapGetters, mapActions } from 'vuex'
    import PreLoader from '@/components/root/Preloader';
    import { getEmptyText } from '@/views/root/GetMessageTextHelper';
    
    export default {
        name: `mltrigger-index`,
        components: {PreLoader},
        data() {
            return {
                command: {},
                currentPage: 1,
                perPage: 50,
                pageOptions: [50, 100, 200],
                filter: '',
                count: -1,
                sortDesc: false
            }
        },
        computed: {
            fields() { 
                return [
                    {
                        key: 'triggerId',
                        label: 'Id',
                        sortable: true
                    },
                    {
                        key: 'vendorname',
                        label: 'Naam',
                        sortable: true
                    },
                    {
                        key: 'kvK',
                        label: 'Kvk'
                    },
                    {
                        key: 'vatNumber',
                        label: 'Btw'
                    },
                    {
                        key: 'iban',
                        label: 'Iban'
                    },                                 
                    {
                        key: 'actions',
                        label: this.$i18n.t('datatables.acties')
                    }
                ]
            },
            ...mapGetters('fmmodule', ['mltriggers']),
        },
        methods: {
            ...mapActions('fmmodule', ['all','executeCommand']),
            onRowClicked(item) {
                this.$router.push({ name: `mltriggers:detail`, params: { triggerId: item.id } });
            },   
            onTriggerDeleted() {
                var vm = this
                vm.count = vm.count - 1;
                this.$refs.table.refresh();
            },
            refreshTable(){
                this.$refs.table.refresh();
            },
            getEmptyText,
            onFiltered (filteredItems) {
                this.count = filteredItems.length;
                this.currentPage = 1
            },
            getFilterQuery: function(filter) {
                var query = '1 eq 1';
    
                if(filter !== '' && filter != null){
                    query += ` and contains(tolower(naam), '${filter}'`
                    query += `)`
                }
                return query;
            },
            getOrderByQuery: function(sortDesc) {
                return sortDesc ;
            },
            TriggerProvider(ctx,callback)
            {
                clearTimeout(this.$_timeout);
                this.$_timeout = setTimeout(() => {
                    let vm = this;
                    vm.all({
                        resource: 'mltriggers',
                        subpath: `/overzicht?Top=${ctx.perPage}&Skip=${ctx.currentPage * ctx.perPage - ctx.perPage}&search=${ctx.filter}&filter=${ctx.sortBy},${ctx.sortDesc ? 'desc' : 'asc'}`,
                    }).then((data) => {
                        vm.count = data.metadata.count;
                        callback(data.result);
                    }).catch(() => {
                        callback([]);
                    })
                },500)
            }
        },
        created() {
            this.$_timeout = null;
                
        },
        beforeDestroy() {
          clearTimeout(this.$_timeout)
      },
    }
    </script>
    <style>
    </style>